import { type QueryClient } from '@tanstack/react-query';

import { extractUndefined } from '@/packages/utils/extractUndefined';

import { type TGetOffersByPinResponse_1 } from '@/repositories/generated/shared/search-offers/v1/get-offers-by-pin';

import { type QueryKey, getQueryKey } from './internal/config';

export class FetchGetOffersByPinLoadService {
  private readonly queryClient: QueryClient;

  public constructor(queryClient: QueryClient) {
    this.queryClient = queryClient;
  }

  public getQueryData(queryKeyParameters: QueryKey[1]): TGetOffersByPinResponse_1 | null {
    return extractUndefined(this.queryClient.getQueryData<TGetOffersByPinResponse_1>(getQueryKey(queryKeyParameters)));
  }

  public setQueryData(
    updater: TGetOffersByPinResponse_1,
    queryKeyParameters: QueryKey[1],
  ): TGetOffersByPinResponse_1 | null {
    return extractUndefined(
      this.queryClient.setQueryData<TGetOffersByPinResponse_1>(getQueryKey(queryKeyParameters), updater),
    );
  }
}
